
import {request} from '@/network/request'

export function cooperativeunit(query) {
    return request({
        url: '/gaoligong/cooperativeunit/getNotCooperativeUnit',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/gaoligong/cooperativeunit',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/gaoligong/cooperativeunit/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/gaoligong/cooperativeunit/' + id,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/gaoligong/cooperativeunit',
        method: 'put',
        data: obj
    })
}
